export const mockData = {
  company: {
    name: 'ELZALIRA',
    tagline: 'Empowering Innovation, Building Resilience',
    established: '2022',
    address: 'Rua Aimutin, Dom Aleixo, Dili, Timor-Leste',
    email: 'info@elzalira.org',
    adminEmail: 'admin@elzalira.org',
    phone: '(+670) 73212112 | 77704984',
    website: 'www.elzalira.org'
  },
  
  services: [
    {
      id: 1,
      title: 'ICT Consultancy & Equipment',
      icon: 'Monitor',
      description: 'Expert consultancy services and equipment for Information & Communication Technology to enhance your digital infrastructure.',
      features: ['Network Infrastructure', 'Hardware & Software Solutions', 'IT Strategy Consulting', 'System Integration']
    },
    {
      id: 2,
      title: 'Electrical & Solar PV Systems',
      icon: 'Zap',
      description: 'Design, installation, operation and maintenance of electrical systems and renewable solar PV solutions.',
      features: ['Solar Panel Installation', 'Lightning Protection', 'Electrical Design', 'System Maintenance']
    },
    {
      id: 3,
      title: 'Civil Construction Work',
      icon: 'Building',
      description: 'Comprehensive civil construction services for office buildings including new construction and rehabilitation projects.',
      features: ['Office Building Construction', 'Building Rehabilitation', 'Structural Engineering', 'Project Management']
    },
    {
      id: 4,
      title: 'Water Sanitation & Hygiene',
      icon: 'Droplet',
      description: 'Innovative solutions for clean water access and sanitation facilities promoting public health.',
      features: ['Sanitation Systems', 'Hygiene Solutions', 'Water Treatment', 'Environmental Sustainability']
    }
  ],
  
  leadership: [
    {
      id: 1,
      name: 'Teresa de Jesus Leite',
      nickname: 'Eza',
      position: 'Chief Executive Officer (CEO)',
      image: null
    },
    {
      id: 2,
      name: 'Rosalino Manuel Ximenes Martins',
      nickname: 'Lino',
      position: 'Chief Technical Officer (CTO)',
      image: null
    }
  ],
  
  projects: [
    {
      id: 1,
      title: 'Solar PV Installation Project',
      category: 'Renewable Energy',
      description: 'Large-scale solar photovoltaic system installation for sustainable energy solutions.',
      year: '2023',
      image: null
    },
    {
      id: 2,
      title: 'Water Distribution Network',
      category: 'Water Infrastructure',
      description: 'Comprehensive water distribution system serving multiple communities.',
      year: '2023',
      image: null
    },
    {
      id: 3,
      title: 'ICT Infrastructure Upgrade',
      category: 'Technology',
      description: 'Complete information and communication technology infrastructure modernization.',
      year: '2024',
      image: null
    },
    {
      id: 4,
      title: 'Sanitation System Implementation',
      category: 'Water Sanitation',
      description: 'Modern sanitation and hygiene system for improved public health.',
      year: '2024',
      image: null
    }
  ],
  
  values: [
    {
      title: 'Integrity',
      description: 'We operate with transparency, honesty, and professionalism.'
    },
    {
      title: 'Quality Excellence',
      description: 'We uphold engineering and technical standards in all our work.'
    },
    {
      title: 'Innovation',
      description: 'We apply modern solutions to advance infrastructure and technology.'
    },
    {
      title: 'Sustainability',
      description: 'We prioritize energy efficiency, environmental responsibility, and long-term performance.'
    },
    {
      title: 'Community Impact',
      description: 'We design solutions that benefit people and strengthen local capacity.'
    },
    {
      title: 'Collaboration',
      description: 'We work closely with clients, partners, and communities.'
    }
  ],
  
  customers: [
    { id: 1, name: 'UNDP Timor-Leste', logo: null },
    { id: 2, name: 'FAO Timor-Leste', logo: null },
    { id: 3, name: 'UN Women', logo: null },
    { id: 4, name: 'ADB in Timor-Leste', logo: null },
    { id: 5, name: 'Chemonics International', logo: null },
    { id: 6, name: 'Palladium Ltd Pty', logo: null },
    { id: 7, name: 'National Directorate of Geophysical and Meteorology of Timor-Leste (DNMG)', logo: null },
    { id: 8, name: 'INFPM (National Institute of Pharmacy and Medical Product)', logo: null },
    { id: 9, name: 'Ministry of Health of Timor-Leste', logo: null }
  ],
  
  partners: [
    { id: 1, name: 'GSOL Energy', location: 'Denmark', logo: null },
    { id: 2, name: 'Enviroearth', location: 'France', logo: null },
    { id: 3, name: 'AllSpark Power', location: 'China', logo: null },
    { id: 4, name: 'Esaviour', location: 'China', logo: null },
    { id: 5, name: 'Smart Media Computer', location: 'Indonesia', logo: null },
    { id: 6, name: 'Micrographics Data', location: 'Singapore', logo: null },
    { id: 7, name: 'signotec GmbH', location: 'Germany', logo: null },
    { id: 8, name: 'Hense Technology Pte. Ltd', location: 'Singapore', logo: null },
    { id: 9, name: 'Varius Technology Pte Ltd', location: 'Singapore', logo: null }
  ]
};